import { Avatar, Box, IconButton, Stack } from "@mui/material";
import Anexar from "../../../components/anexar";
import ViewCad from "../../../config/view";
import { getImg, isEmpty } from "../../../services/utils";
import { MedicoViewProps } from "../medico.controller";
import { Medico } from "../medico.model";
import { Cancel, FindReplace } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { db } from "../../../services/db";

interface MedicoCadastroProps extends MedicoViewProps {
    handleCloseView: () => any
}

export function MedicoCadastro(props: MedicoCadastroProps) {
    const { medicoActions, medicoState, handleCloseView } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status } = medicoState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue, addAnexoDoc,remAnexoDoc } = medicoActions
    const [img, setImg] = useState("")
    console.log("img", img);
    useEffect(() => {
        getAttachment()
        return URL.revokeObjectURL(img);
    }, [row._rev])

    const handleNovo = () => {
        setClearValue();
    }

    const handleExcluir = (row: Medico) => {
        deletar(row);
        setShowDialogExluir(false);
        handleCloseView();
    }

    const formValidate = (values: Medico) => {
        const errors: any = {}
        if (!values.nome)
            errors.nome = "Informe o nome do profissional"
        return errors
    }

    const handleUpdate = (value: Medico) => {
        if (!value._rev) {
            create(value);
        } else {
            update(value);
        }
    }

    const getAnexoId = () => {
        let imgList: any[] = []
        if (row._attachments) {
            for (const key in row._attachments) {
                imgList.push(key);
            }
            console.log("imgList", imgList)
            if (imgList.length > 0)
                return imgList[0];
            else return ""
        } else {
            return ""
        }

    }

    const getAttachment = async () => {
        let idAnexo = getAnexoId();
        if (idAnexo) {
            let respGetAnexo = await db.getAnexoDoc(row._id, idAnexo) as any;
            if (respGetAnexo.status === "ok" && respGetAnexo.data) {
                let blob = URL.createObjectURL(respGetAnexo.data as Blob);
                setImg(blob)
            }
        }
    }
    const AddImagemSel = (img: Blob) => {
        let anexo_id = getAnexoId();
        addAnexoDoc({ row: row, anexo: img, anexo_id: anexo_id });
    }

    const removeImg = () => {
        let anexo_id = getAnexoId();
        URL.revokeObjectURL(img)
        setImg("")        
        remAnexoDoc({anexo_id,row})
    }

    var viewCad = new ViewCad({
        formTitle: "Cadastro do Profissional",
        formFieldDescription: "nome",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: true,
            title: "Adicionar novo profissional",
            onClick: () => handleNovo(),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        contentForm: [
            { fieldName: "nome", label: "Medico", type: "text", key: "nome", colunsXS: 12, colunsSM: 12, colunsMD: 12, require: true },
            { fieldName: "especialidade", label: "Especialidade", type: "text", key: "especialidade", colunsXS: 12, colunsSM: 12, colunsMD: 12, require: true },
        ],
        ContentBox: (props) => {
            const { values, form } = props!
            const [showAnexo, setShowAnexo] = useState(false);
            if (values._id)
                return (
                    <>
                        <Box sx={{ mt: 2, display: "flex", flexDirection: "row" }}>
                            <Avatar
                                alt={values.nome}
                                variant="rounded"
                                src={img ? img : values.nome}
                                style={{ width: 150, height: 150, alignSelf: 'center', padding: 5, objectFit: "fill" }}
                            />
                            <Stack direction={"column"}>
                                <IconButton color="secondary" onClick={() => removeImg()}>
                                    <Cancel />
                                </IconButton>
                                <IconButton color="primary" onClick={() => setShowAnexo(true)}>
                                    <FindReplace />
                                </IconButton>
                            </Stack>
                        </Box>
                        <Anexar
                            open={showAnexo}
                            setOpen={setShowAnexo}
                            confirmar={AddImagemSel}
                            anexoAtual={getAnexoId()}
                            urlAtual={img ? img : values.nome}
                        />
                    </>
                )
            return <></>
        }
    })

    return viewCad
}



